import CommentAPI from '@/apis/business/newsfeed/comment-api.js'
import Enumeration from '@/common/enumeration.js'
export default {
  namespaced: true,
  state: {
    comments: [],
    listUserTags: [],
    postComment: {

    },
    postHocMaiParams: {
      LessonID: '',
      TopicID: '',
      ThematicID: '',
      CourseID: '',
      PostType: 0
    },
    userLike: [],
    commentReplyStore: null,
    isReplyClick: false
  },
  getters: {

  },
  mutations: {

    onReplyClick (state) {
      state.isReplyClick = !state.isReplyClick
    },

    setComment (state, comments) {
      state.comments = [...comments]
    },
    setCommentReply (state, comment) {
      state.commentReplyStore = comment
    },

    setlistUserTags (state, listUser) {
      state.listUserTags = listUser
    },

    /**
     * Thêm bình luận vào danh sách bình luận sau khi thêm
     * @param {*} state
     * @param {*} comment
     */
    pushCommentToTop (state, comment) {
      // Tìm vị trí comment cha của commetn con mới thêm
      if (comment.level === Enumeration.CommentLevel.LevelTwo) {
        // Vị trí comment được reply
        const index = state.comments.findIndex(commentItem => commentItem.Id === comment.ParentCommentId)
        let check = false
        for (let i = index + 1; i < state.comments.length; i++) {
          const element = state.comments[i]
          if (element.Level === Enumeration.CommentLevel.LevelOne) {
            // Thêm comment con vào sau vị trí comment cha
            state.comments.splice(i, 0, comment)
            check = true
            break
          }
        }
        if (!check) {
          state.comments.splice(state.comments.length, 0, comment)
        }
      } else {
        var arrKeys = state.comments.map(el => el.ParentCommentID)
        var index = arrKeys.lastIndexOf(comment.ParentCommentId)
        if (index !== -1) {
          // Thêm comment con vào sau vị trí comment cha
          state.comments.splice(index + 1, 0, comment)
        } else {
          arrKeys = state.comments.map(el => el.Id)
          index = arrKeys.lastIndexOf(comment.ParentCommentId)
          if (index !== -1) {
            state.comments.splice(index + 1, 0, comment)
          }
        }
      }
    },

    /**
     * Push bình luận vào cuối danh sách
     * @param {*} state
     * @param {*} listComment
     */
    setCommentPagingQueue (state, listComment) {
      // var preCommentLevel
      listComment.PageData.forEach(comment => {
        state.comments.push(comment)
      })
    },
    /**
     * Push bình luận vào đầu danh sách
     * @param {*} state
     * @param {*} listComment
     */
    setCommentPagingStack (state, listComment) {
      // var preCommentLevel
      listComment.PageData.forEach(comment => {
        state.comments.unshift(comment)
      })
    },
    /**
     * Append phần tử đánh dấu input reply
     * @param {*} state
     * @param {*} parentCommentId
     */
    setInputReply (state, parmas) {
      const replyInput = { ...parmas }
      replyInput.timeUpdate = Date.now()
      // Loại bỏ các input reply
      state.comments = state.comments.filter(x => !x.replyInput)
      // Tìm vị trí comment cha của commetn con mới thêm
      if (replyInput.level === Enumeration.CommentLevel.LevelTwo) {
        // Vị trí comment được reply
        const index = state.comments.findIndex(comment => comment.Id === parmas.parentCommentId)
        let check = false
        for (let i = index + 1; i < state.comments.length; i++) {
          const element = state.comments[i]
          if (element.Level === Enumeration.CommentLevel.LevelOne) {
            // Thêm comment con vào sau vị trí comment cha
            state.comments.splice(i, 0, replyInput)
            check = true
            break
          }
        }
        if (!check) {
          state.comments.splice(state.comments.length, 0, replyInput)
        }
      } else {
        var arrKeys = state.comments.map(el => el.ParentCommentID)
        var index = arrKeys.lastIndexOf(parmas.parentCommentId)
        if (index !== -1) {
          // Thêm comment con vào sau vị trí comment cha
          state.comments.splice(index + 1, 0, replyInput)
        } else {
          arrKeys = state.comments.map(el => el.Id)
          index = arrKeys.lastIndexOf(parmas.parentCommentId)
          if (index !== -1) {
            state.comments.splice(index + 1, 0, replyInput)
          }
        }
      }
    },

    /**
     * Loại bỏ các input reply
     */
    resetInputReply (state) {
      state.comments = state.comments.filter(x => !x.replyInput)
    },

    pushListCommentToTop (state, commentsChild) {
      if (commentsChild?.length > 0) {
        var parentId = commentsChild[0].ParentCommentID
        var index = state.comments.findIndex(x => x.Id === parentId)
        commentsChild.forEach(comment => {
          state.comments.splice(++index, 0, comment)
        })
      }
    },

    updateListComment (state, comment) {
      var index = state.comments.findIndex(x => x.Id === comment.Id)
      // gán lại giá trị bình luận trong danh sách
      state.comments[index] = comment
    },

    setDeleteComment (state, commentId) {
      state.comments = state.comments.filter(comment => comment.Id !== commentId && comment.ParentCommentID !== commentId)
    },

    setPostHocMai (state, params) {
      state.postHocMaiParams = params
    },

    setUserLike (state, listComment) {
      state.userLike = listComment
    }
  },
  actions: {
    /**
     * Lấy danh sách bình luận bằng ID bài post và level
     * @param {*} context
     * @param {*} params
     */
    async getCommentsByPostIdAndLevel (context, params) {
      try {
        var res = await CommentAPI.getAsync(`/comments?postId=${params?.postId ? params?.postId : ''}&level=${params?.level}&skip=${params?.skip}&limit=${params?.limit}`)
        context.commit('setComment', res.Data)
      } catch (error) {

      }
    },

    /**
     * Lấy danh sách bình luận bằng paging
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getCommetsByPaging (context, params) {
      try {
        var res = await CommentAPI.getAsync(`/comments-paging?postId=${params?.postId ? params?.postId : ''}&pageIndex=${params?.pageIndex}&pageSize=${params?.pageSize}`)
        if (params.pageIndex > 1) {
          context.commit('setCommentPagingStack', res.Data)
        } else {
          context.commit('setCommentPagingQueue', res.Data)
        }
        return res.Data
      } catch (error) {

      }
    },

    async getListStudentFormal (context, studentId) {
      try {
        var res = await CommentAPI.getAsync(`/students?studentId=${studentId}`)
        context.commit('setlistUserTags', res?.Data)
      } catch (error) {

      }
    },

    /**
     * Lấy danh sách bình luận bằng ID comment cha
     * @param {*} context
     * @param {*} params
     */
    async getCommentsByParentId (context, params) {
      try {
        var res = await CommentAPI.getAsync(`/comments/child?parentId=${params?.parentId ? params?.parentId : ''}&skip=${params?.skip}&limit=${params?.limit}`)
        context.commit('pushListCommentToTop', res.Data)
      } catch (error) {

      }
    },

    /**
     * Thả biểu tượng cảm xúc cho comment
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async likeComment (context, params) {
      try {
        const res = await CommentAPI.postAsync(`/like?commentId=${params?.commentId}&likeType=${params?.likeType}`, params)
        return res.Data
      } catch (error) {

      }
    },

    /**
     * Thêm bình luận vào db
     * @param {*} context
     * @param {*} comment
     */
    async insertComment (context, comment) {
      try {
        var res = await CommentAPI.postAsync('/insert-comment', comment)
        if (res.Data) {
          context.commit('pushCommentToTop', res.Data)
        }
      } catch (error) {

      }
    },

    /**
     * Cập nhật bình luận
     * @param {*} context
     * @param {*} comment
     * @returns
     */
    async updateComment (context, comment) {
      try {
        const res = await CommentAPI.putAsync(`/update-comment?commentId=${comment.Id}`, comment)
        if (res.Data) {
          context.commit('updateListComment', comment)
        }
        return res.Data
      } catch (error) {

      }
    },

    /**
     * Xóa bình luận
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async deleteComment (context, params) {
      try {
        const res = await CommentAPI.deleteAsync(`/delete-comment?commentId=${params.commentId}&commentParentId=${params.commentParentId ? params.commentParentId : ''}&postId=${params.postId}`)
        if (res.Data) {
          context.commit('setDeleteComment', params.commentId)
        }
        return res.Data
      } catch (error) {

      }
    },

    /**
     * Lấy danh sách người like Comment
     * @param {*} context
     * @param {*} commentId
     */
    async getUserLike (context, commentId) {
      try {
        const res = await CommentAPI.getAsync(`/like-users?commentId=${commentId}`)
        context.commit('setUserLike', res.Data)
      } catch (error) {

      }
    }
  }
}
